(function () {
  'use strict';

  class Helpers {
    // Parents Node
    // same like: jQuery parents();
    // eslint-disable-next-line class-methods-use-this
    parents(node) {
      let current = node;
      let list = [];
      while (current.parentNode != null && current.parentNode !== document.documentElement) {
        list.push(current.parentNode);
        current = current.parentNode;
      }
      return list;
    }

    /**
     * is Visible
     * @param el
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    isVisible(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    /**
     * is Hidden
     * @param el
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    isHidden(el) {
      const style = window.getComputedStyle(el);
      return style.display === 'none' || style.visibility === 'hidden';
    }

    /**
     * checkVisible
     * @param elm
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    checkVisible(elm) {
      const rect = elm.getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }

    /**
     * scrollingProgress
     * @returns {number}
     */
    // eslint-disable-next-line class-methods-use-this
    scrollingProgress() {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      return winScroll / height * 100;
    }

    /**
     * getRandomChartColor
     * @param count
     * @param opposite
     * @returns {*[]}
     */
    // eslint-disable-next-line class-methods-use-this
    getRandomChartColor(count, opposite = false) {
      const flatColors = ['#1abc9c', '#e74c3c', '#f1c40f', '#3498db', '#f39c12', '#2ecc71', '#8e44ad', '#27ae60', '#e67e22', '#a29bfe', '#ff7675', '#d35400', '#2980b9', '#16a085', '#c0392b', '#9b59b6', '#34495e', '#55efc4', '#81ecec', '#74b9ff', '#00b894', '#00cec9', '#0984e3', '#6c5ce7', '#ffeaa7', '#fab1a0', '#fd79a8', '#fdcb6e', '#e17055'];
      const colors = [];
      if (opposite) {
        for (let i = 0; i < count; i++) {
          if (i === 0) {
            colors.push('#FFFFFF'); // Beyaz için ilk değer
          } else if (i === count - 1) {
            colors.push('#808080'); // Gri için son değer
          } else {
            colors.push(flatColors[i]);
          }
        }
      } else {
        for (let i = 0; i < count; i++) {
          colors.push(flatColors[i]);
        }
      }
      return colors;
    }

    /**
     * getColor
     * @param color
     * @returns {*|boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    getColor(color) {
      const colors = {
        primary: '#2bace2',
        border: '#e8e8ee',
        'neutral-100': '#f5f7f9',
        'neutral-200': '#eceff3',
        'neutral-300': '#dadee6',
        'neutral-400': '#c0c7d3',
        'neutral-500': '#959fb2',
        'neutral-600': '#636d7e',
        'neutral-700': '#394456',
        'neutral-800': '#1c2536',
        'neutral-900': '#00041a'
      };
      return colors[color] || false;
    }

    /**
     * formatNumber
     * @param num
     * @returns {string}
     */
    // eslint-disable-next-line class-methods-use-this
    formatNumber(num) {
      return num.toLocaleString();
    }

    /**
     * unFormatNumber
     * @param formattedNum
     * @returns {*}
     */
    // eslint-disable-next-line class-methods-use-this
    unformatNumber(formattedNum) {
      return formattedNum.replace(/,/g, '');
    }

    /**
     * sleep
     * @param ms
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line class-methods-use-this
    sleep(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    }

    /**
     * Check if JS component(s) are loaded
     * @param {Element} element - DOM element to check
     * @param {string|string[]} components - Component name(s) to check
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    hasJSLoaded(element, components) {
      const loadedAttr = element.getAttribute('data-js-loaded');
      if (!loadedAttr) return false;
      const loadedComponents = loadedAttr.split(',').map(comp => comp.trim());
      if (Array.isArray(components)) {
        return components.every(component => loadedComponents.includes(component));
      }
      return loadedComponents.includes(components);
    }

    /**
     * Set JS component(s) as loaded
     * @param {Element} element - DOM element to mark
     * @param {string|string[]} components - Component name(s) to mark as loaded
     */
    // eslint-disable-next-line class-methods-use-this
    setJSLoaded(element, components) {
      const existingAttr = element.getAttribute('data-js-loaded');
      let loadedComponents = existingAttr ? existingAttr.split(',').map(comp => comp.trim()) : [];
      const componentsToAdd = Array.isArray(components) ? components : [components];
      componentsToAdd.forEach(component => {
        if (!loadedComponents.includes(component)) {
          loadedComponents.push(component);
        }
      });
      element.setAttribute('data-js-loaded', loadedComponents.join(','));
    }

    /**
     * Unset JS component(s) as loaded
     * @param {Element} element - DOM element to unmark
     * @param {string|string[]} components - Component name(s) to mark as not loaded
     */
    // eslint-disable-next-line class-methods-use-this
    removeJSLoaded(element, components) {
      const existingAttr = element.getAttribute('data-js-loaded');
      if (!existingAttr) return;
      const componentsToRemove = Array.isArray(components) ? components : [components];
      const loadedComponents = existingAttr.split(',').map(comp => comp.trim()).filter(comp => comp && !componentsToRemove.includes(comp));
      if (loadedComponents.length) {
        element.setAttribute('data-js-loaded', loadedComponents.join(','));
      } else {
        element.removeAttribute('data-js-loaded');
      }
    }
  }
  const {
    checkVisible,
    isVisible,
    isHidden,
    parents,
    scrollingProgress,
    getRandomChartColor,
    getColor,
    formatNumber,
    unformatNumber,
    sleep,
    hasJSLoaded,
    setJSLoaded,
    removeJSLoaded
  } = Helpers.prototype;

  /**
   * Leaflet Map
   * @author Mert Osman Başol
   * @email mert.basol@magicport.ai
   */

  class LeafletMap {
    constructor(mapElementId, options = {}) {
      this.map = null;
      this.mapElementId = mapElementId;
      this.markers = [];
      this.currZoom = options.initialZoom || 14;
      this.iconSize = options.iconSize || [32, 32];
      this.flagPath = 'https://magicport.ai/front/flags/';
      this.markerType = mapElementId.dataset.mapMarker || 'ship';
      this.markerColor = mapElementId.dataset.mapColor || '#1e295b';
      this.markerColors = options.markerColors || {
        boat: {
          default: {
            fill: '#C8C8C8',
            stroke: '#565656'
          },
          cargo: {
            fill: '#86F793',
            stroke: '#01650C'
          },
          fishing: {
            fill: '#FFFF51',
            stroke: '#F09917'
          },
          passenger: {
            fill: '#036AEE',
            stroke: '#002B62'
          },
          'pleasure-craft': {
            fill: '#49FFFF',
            stroke: '#095F5F'
          },
          tanker: {
            fill: '#DF2329',
            stroke: '#740307'
          },
          'tugs-support-vessels': {
            fill: '#FF70FF',
            stroke: '#700C70'
          },
          container: {
            fill: '#FFBE9A',
            stroke: '#A04C1D'
          },
          'bulk-carrier': {
            fill: '#52DD62',
            stroke: '#216729'
          },
          'ro-ro': {
            fill: '#C3E972',
            stroke: '#0B5914'
          },
          'gas-carrier': {
            fill: '#FF5E63',
            stroke: '#9D0005'
          },
          bunkering: {
            fill: '#FFACA0',
            stroke: '#9D0005'
          },
          offshore: {
            fill: '#E445E4',
            stroke: '#8A008A'
          },
          'special-craft': {
            fill: '#FDC0FD',
            stroke: '#912691'
          }
        }
      };
      this.options = options;
    }
    getMarkerColor(type) {
      const markerAliases = {
        'general-cargo': 'cargo',
        'tugs-harbor-craft': 'tugs-support-vessels'
      };
      const key = markerAliases[type] || type;
      return this.markerColors.boat[key] !== undefined ? this.markerColors.boat[key] : this.markerColors.boat.default;
    }
    async init() {
      await this.loadLeaflet();
      this.addRotationSupport();
      this.initMap(this.options.locations);
      const resizeObserver = new ResizeObserver(() => {
        this.refreshUI();
      });
      resizeObserver.observe(this.mapElementId);
    }

    // eslint-disable-next-line class-methods-use-this
    loadLeaflet() {
      return new Promise(resolve => {
        if (typeof L === 'undefined') {
          const leafletCSS = document.createElement('link');
          leafletCSS.rel = 'stylesheet';
          leafletCSS.href = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.css';
          document.head.appendChild(leafletCSS);
          const leafletScript = document.createElement('script');
          leafletScript.src = 'https://unpkg.com/leaflet@1.7.1/dist/leaflet.js';
          leafletScript.onload = resolve;
          document.head.appendChild(leafletScript);
        } else {
          resolve();
        }
      });
    }

    // eslint-disable-next-line class-methods-use-this
    addRotationSupport() {
      // eslint-disable-next-line camelcase,no-underscore-dangle,no-undef
      const proto_initIcon = L.Marker.prototype._initIcon;
      // eslint-disable-next-line camelcase,no-underscore-dangle,no-undef
      const proto_setPos = L.Marker.prototype._setPos;

      // eslint-disable-next-line no-undef
      const oldIE = L.DomUtil.TRANSFORM === 'msTransform';

      // eslint-disable-next-line no-undef
      L.Marker.addInitHook(function () {
        const iconOptions = this.options.icon && this.options.icon.options;
        let iconAnchor = iconOptions && this.options.icon.options.iconAnchor;
        if (iconAnchor) {
          iconAnchor = `${iconAnchor[0]}px ${iconAnchor[1]}px`;
        }
        this.options.rotationOrigin = this.options.rotationOrigin || iconAnchor || 'center bottom';
        this.options.rotationAngle = this.options.rotationAngle || 0;

        // Ensure marker keeps rotated during dragging
        this.on('drag', function (e) {
          // eslint-disable-next-line no-underscore-dangle
          e.target._applyRotation();
        });
      });

      // eslint-disable-next-line no-undef
      L.Marker.include({
        // eslint-disable-next-line no-underscore-dangle
        _initIcon() {
          // eslint-disable-next-line camelcase
          proto_initIcon.call(this);
        },
        // eslint-disable-next-line no-underscore-dangle
        _setPos(pos) {
          // eslint-disable-next-line camelcase
          proto_setPos.call(this, pos);
          // eslint-disable-next-line no-underscore-dangle
          this._applyRotation();
        },
        // eslint-disable-next-line no-underscore-dangle
        _applyRotation() {
          if (this.options.rotationAngle) {
            // eslint-disable-next-line no-underscore-dangle,no-undef
            this._icon.style[`${L.DomUtil.TRANSFORM}Origin`] = this.options.rotationOrigin;
            if (oldIE) {
              // for IE 9, use the 2D rotation
              // eslint-disable-next-line no-underscore-dangle,no-undef
              this._icon.style[L.DomUtil.TRANSFORM] = `rotate(${this.options.rotationAngle}deg)`;
            } else {
              // eslint-disable-next-line no-underscore-dangle,no-undef
              this._icon.style[L.DomUtil.TRANSFORM] += ` rotateZ(${this.options.rotationAngle}deg)`;
            }
          }
        },
        setRotationAngle(angle) {
          this.options.rotationAngle = angle;
          this.update();
          return this;
        },
        setRotationOrigin(origin) {
          this.options.rotationOrigin = origin;
          this.update();
          return this;
        }
      });
    }
    initMap(locations) {
      if (this.map) {
        this.map.off();
        this.map.remove();
      }
      const isSingle = locations && locations.length === 1;
      // if (isSingle) this.currZoom = 12;

      // eslint-disable-next-line no-undef
      this.map = L.map(this.mapElementId, {
        minZoom: 2,
        maxZoom: 19
      }).setView(isSingle ? [locations[0]?.lat, locations[0]?.lng] : [0, 0], locations && locations.length > 0 ? this.currZoom : 3);

      // eslint-disable-next-line no-undef
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        className: 'map-tiles',
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(this.map);
      if (locations && locations.length > 0) {
        this.setMarkers(locations);
        if (!isSingle) {
          this.zoomIcons(this.currZoom, this.map.getZoom());
          this.map.on('zoomend', () => {
            this.zoomIcons(this.currZoom, this.map.getZoom());
            this.currZoom = this.map.getZoom();
          });
          this.markersFitBounds(this.markers);
        }
      }
    }
    setData(locations) {
      if (this.map) {
        this.markers.forEach(marker => this.map.removeLayer(marker));
        this.markers = [];
        this.setMarkers(locations);
        this.markersFitBounds(this.markers);
      }
    }

    // eslint-disable-next-line class-methods-use-this
    cssMultiply(cssVal, multiplier) {
      const returnval = cssVal.substring(0, cssVal.match(/[A-Za-z]/).index) * multiplier;
      return returnval + cssVal.substring(cssVal.match(/[A-Za-z]/).index);
    }
    zoomIcons(oldZoom, newZoom) {
      const difference = newZoom - oldZoom ? newZoom - oldZoom : oldZoom - 12;
      const moreRatio = 1.177777772;
      const lessRatio = 0.84;
      const zoomRatio = difference > 0 ? moreRatio : lessRatio;
      const limit = 6;
      const icons = document.querySelectorAll('.shipIcon');
      icons.forEach(item => {
        if (this.map?.getZoom() < limit) {
          // eslint-disable-next-line no-param-reassign
          item.style.width = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[0] * 0.5}px` : `${this.iconSize[0] * 0.5}px`;
          // eslint-disable-next-line no-param-reassign
          item.style.height = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[1] * 0.5}px` : `${this.iconSize[1] * 0.5}px`;
          // eslint-disable-next-line no-param-reassign
          item.style.marginLeft = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[0] * 0.5 / 2 * -1}px` : `${this.iconSize[0] * 0.5 / 2 * -1}px`;
          // eslint-disable-next-line no-param-reassign
          item.style.marginTop = item.classList.contains('shipIcon--circle') ? `${this.iconSizeCircle[1] * 0.5 / 2 * -1}px` : `${this.iconSize[1] * 0.5 / 2 * -1}px`;
        } else if (difference < -1) {
          this.currZoom = this.map.getZoom();
          // eslint-disable-next-line no-plusplus
          for (let i = 1; i < difference * -1; i++) {
            // eslint-disable-next-line no-param-reassign
            item.style.width = this.cssMultiply(item.style.width, lessRatio);
            // eslint-disable-next-line no-param-reassign
            item.style.height = this.cssMultiply(item.style.height, lessRatio);
            // eslint-disable-next-line no-param-reassign
            item.style.marginLeft = this.cssMultiply(item.style.marginLeft, lessRatio);
            // eslint-disable-next-line no-param-reassign
            item.style.marginTop = this.cssMultiply(item.style.marginTop, lessRatio);
          }
        } else {
          // eslint-disable-next-line no-param-reassign
          item.style.width = this.cssMultiply(item.style.width, zoomRatio);
          // eslint-disable-next-line no-param-reassign
          item.style.height = this.cssMultiply(item.style.height, zoomRatio);
          // eslint-disable-next-line no-param-reassign
          item.style.marginLeft = this.cssMultiply(item.style.marginLeft, zoomRatio);
          // eslint-disable-next-line no-param-reassign
          item.style.marginTop = this.cssMultiply(item.style.marginTop, zoomRatio);
        }
      });
    }
    setMarkers(locations) {
      if (typeof locations === 'undefined') return;
      const that = this;
      locations.forEach(location => {
        if (location?.lat && location?.lng) {
          const iconSVG = this.getMarkerIcon(this.markerType, location);
          const size = this.getMarkerSize(location?.length);

          // eslint-disable-next-line no-undef
          const icon = L.divIcon({
            html: iconSVG,
            className: `shipIcon${!location?.speed || location?.speed === 0 ? ' shipIcon--circle' : ''}`,
            iconSize: size,
            iconAnchor: [size[0] / 2, size[1] / 3]
          });

          // eslint-disable-next-line no-undef,new-cap
          const marker = new L.marker([location.lat, location.lng], {
            icon,
            rotationAngle: location?.course
          }).addTo(this.map).on('mouseover', function () {
            that.customTooltip(location, this);
          });
          this.markers.push(marker);
        }
      });
    }

    /**
     * getMarkerIcon
     * @param type
     * @param data
     * @returns {string}
     */
    // eslint-disable-next-line default-param-last
    getMarkerIcon(type = 'ship', data) {
      let icon = '';

      // console.log('type', type);

      if (type === 'ship' && data) {
        const color = this.getMarkerColor(data?.type);
        // eslint-disable-next-line no-unused-expressions
        icon = !data?.speed || data?.speed === 0 ? `
          <svg width="100%" height="100%" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="16.25" y="16.25" width="25.5" height="25.5" rx="12.75" fill="${color.fill}" stroke="${color.stroke}" stroke-width="2.5"/>
          </svg>
        ` : `
        <svg width="100%" height="100%" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.8447 43.9119L29 43.1376L28.1553 43.9119L20.9482 50.5184C20.681 50.7634 20.25 50.5738 20.25 50.2113V24.7378C20.25 23.5695 20.539 22.4194 21.0912 21.3898L28.6328 7.32915C28.79 7.03619 29.21 7.03619 29.3672 7.32915L36.9088 21.3898C37.461 22.4194 37.75 23.5695 37.75 24.7378V50.2113C37.75 50.5738 37.319 50.7634 37.0518 50.5184L29.8447 43.9119Z" fill="${color.fill}" stroke="${color.stroke}" stroke-width="2.5"/>
            <rect x="28.1667" y="24.8333" width="1.66667" height="11.6667" rx="0.833333" fill="${color.stroke}" stroke="${color.stroke}" stroke-width="1.66667"/>
        </svg>
      `;
      }
      if (type === 'normal') {
        icon = `
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0z"/><path fill="${this.markerColor}" d="M18.364 17.364L12 23.728l-6.364-6.364a9 9 0 1 1 12.728 0zM12 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
      `;
      }
      return icon;
    }
    customTooltip(data, _) {
      if (!data?.name) return;
      _.unbindTooltip();
      if (!_.isPopupOpen()) _.bindTooltip(`
          <div class="d-flex p-025 align-items-center">
              <div style="width: 32px;" class="mr-05">
                  <img src="${this.flagPath}/${data?.flag.toLowerCase()}.svg" alt="" style="width: 100%; border-radius: 3px; height: auto;">
              </div>
              <div class="d-flex flex-column">
                  <strong class="text-style text-style--small text-style--semi text-dark text-style--lh-base">${data?.name}</strong>
                  ${data?.mmsi ? `<span class="text-style text-style--xsmall text--gray-500 text-style--lh-base">MMSI: ${data?.mmsi}</span>` : `${data?.imo ? `<span class="text-style text-style--xsmall text--gray-500 text-style--lh-base">IMO: ${data?.imo}</span>` : ''}`}
              </div>
          </div>
          `, {
        direction: 'top',
        offset: [0, -10]
      }).openTooltip();
    }
    getMarkerSize(length) {
      if (!length) return this.iconSize;
      if (!length || length <= 100) return [15, 15];
      if (length > 100 && length <= 200) return [20, 20];
      return [29, 29];
    }
    markersFitBounds(markers) {
      if (typeof markers === 'undefined' || markers.length === 0) return;

      // eslint-disable-next-line new-cap,no-undef
      const group = new L.featureGroup(markers);
      this.map.fitBounds(group.getBounds(), {
        maxZoom: 14,
        padding: markers.length > 1 ? [20, 20] : [0, 0]
      });
    }
    refreshUI() {
      if (this.map && typeof this.map.invalidateSize === 'function') {
        this.map.invalidateSize();
      }
    }
  }

  const initMap = async () => {
    let map = null;
    const locations = [];
    const maps = document.querySelectorAll('[data-magicmap], [data-leaflet-map]');
    let mapElement = null;
    if (!maps || maps?.length === 0) return;
    for (const m of maps) {
      if (isVisible(m)) {
        mapElement = m;
        if (!mapElement) return;
        locations.push({
          "id": m.dataset.mapImo,
          "name": mapElement.dataset.mapName,
          "lat": mapElement.dataset.mapLat,
          "lng": mapElement.dataset.mapLng,
          "flag": mapElement.dataset.mapFlag,
          "type": mapElement.dataset.mapType,
          "shipType": null,
          "destination": null,
          "course": mapElement.dataset.mapCourse,
          "speed": mapElement.dataset.mapSpeed,
          "length": mapElement.dataset.mapLength,
          "mmsi": mapElement.dataset.mapMmsi
        });
        if (mapElement?.hasAttribute('data-leaflet-map')) {
          map = new LeafletMap(m);
          await map.init(); // ✅ Now 'await' works correctly
        }
        map.setData(locations);
      }
    }
  };
  (() => {
    document.addEventListener('DOMContentLoaded', async () => {
      await initMap();
    });
  })();

})();
